import { render, staticRenderFns } from "./SubNode.vue?vue&type=template&id=68760b60&scoped=true"
import script from "./SubNode.vue?vue&type=script&lang=js"
export * from "./SubNode.vue?vue&type=script&lang=js"
import style0 from "./SubNode.vue?vue&type=style&index=0&id=68760b60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68760b60",
  null
  
)

export default component.exports